import { CSSProperties } from 'react';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useActiveUserContext, useAppConfigContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { DataRequestTabComponent } from './data-request-tab.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const tabsContainerStyle: CSSProperties = {
    minWidth: 250,
    maxWidth: 250,
    display: 'flex',
    flexDirection: 'column',
};

const bottomDivStyle: CSSProperties = {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.1) 0px 1px 3px',
    background: 'white',
    position: 'relative',
    zIndex: 14,
    display: 'flex',
    flexGrow: 2,
};

export const DataRequestTabsComponent = () => {
    const { dataRequest, showResearchResults, organizations, isActiveUserOrgAdmin } = useDataRequestContext();
    const config = useAppConfigContext();
    const { user: activeUser, hasAnyPermission, hasPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    const isOrgAdmin = hasAnyPermission(PermissionsEnum.ProviderActAdv);
    const { shouldHideReviewers } = useDataRequestPermissionsContext();
    const studies = dataRequest.requestedStudies;
    const isVivliAdmin = hasPermission(PermissionsEnum.DrActAdv);

    const isOrgAdminRestricted = () => {
        let isRestricted = false;
        const isDrOwner = dataRequest.userId === activeUser.userId;
        const isTeamMember = dataRequest.researchTeam.researchTeamDetails.find((x) => x.userId === activeUser.userId);
        //TODO PERMFE - redo with permissions+
        const isAdmin = hasPermission(PermissionsEnum.DrActAdv);

        if (!isAdmin && isOrgAdmin && !(isDrOwner || isTeamMember)) {
            const orgNames = {};
            organizations.forEach((org) => {
                orgNames[org.name] = true;
            });

            isRestricted = true;
            studies.forEach((study) => {
                if (orgNames[study.organizationName] || orgNames[study.approvalBodyOrgName]) {
                    isRestricted = false;
                }
            });
            /* seems like the code above should be replaced to the code below, but leaving as is for now
            because it is too close to the release
            isRestricted = !studies.some((study) =>
                organizations.some((org) => org.id === study.approvalBodyOrgId || org.id === study.organizationId)
            );*/
        }

        return isRestricted;
    };

    const canShowPublishing = () => {
        //TODO PERMFE - redo with permissions+
        const canShow =
            isVivliAdmin &&
            (dataRequest.status === DataRequestStatusEnum.DUAValidated ||
                dataRequest.status === DataRequestStatusEnum.PartiallyFulfilled ||
                dataRequest.status === DataRequestStatusEnum.Fulfilled ||
                dataRequest.status === DataRequestStatusEnum.Archived ||
                (dataRequest.secondaryAnalysisDoi !== null && dataRequest.secondaryAnalysisDoi !== ''));
        return canShow;
    };

    const getTabs = (): string[] => {
        let dataRequestTabs = ['Studies', 'Attachments', 'Request History'];
        //TODO PERMFE - redo with permissions+
        const shouldShowStatusUpdate = isVivliAdmin || isOrgAdmin;
        const shouldShowChat = config.chatEnabled && config.chatUri && config.chatUri.length > 0;
        const hideReviewers = shouldHideReviewers(dataRequest, organizations);
        const teamMember = dataRequest.researchTeam.researchTeamDetails.find((x) => x.userId === activeUser.userId);

        if (!hideReviewers) {
            dataRequestTabs.push('Signed Agreements');
        }

        if (dataRequest.status === DataRequestStatusEnum.Fulfilled || dataRequest.status === DataRequestStatusEnum.PartiallyFulfilled) {
            dataRequestTabs.push('Safety Concerns');
        }

        if (showResearchResults) {
            dataRequestTabs.push('Research Results');
        }

        if (shouldShowStatusUpdate) {
            dataRequestTabs.splice(1, 0, 'Status Update');
        }

        if (shouldShowChat) {
            dataRequestTabs.push('Chat');
        }
        //TODO PERMFE - redo with permissions+
        if ((isVivliAdmin || dataRequest.userId === activeUser.userId || teamMember || isActiveUserOrgAdmin()) && !hideReviewers) {
            dataRequestTabs.push('Research Team');
        }

        if (
            dataRequest.status === DataRequestStatusEnum.Fulfilled ||
            dataRequest.status === DataRequestStatusEnum.Archived ||
            dataRequest.status === DataRequestStatusEnum.PartiallyFulfilled
        ) {
            dataRequestTabs.push('Research Environment');
            dataRequestTabs.push('Public Disclosures');
            dataRequestTabs.push('All Citations');
        }

        //TODO PERMFE - redo with permissions+
        if (dataRequest.status !== DataRequestStatusEnum.Draft || isVivliAdmin || isOrgAdminRestricted()) {
            dataRequestTabs.push('Request Details/Print View');
        }

        if (canShowPublishing()) {
            dataRequestTabs.push('Publish Approved Request');
        }

        return dataRequestTabs;
    };

    return (
        <div style={tabsContainerStyle}>
            {getTabs().map((title, i) => (
                <DataRequestTabComponent title={title} key={i} />
            ))}

            <div style={bottomDivStyle} />
        </div>
    );
};
